import { render, staticRenderFns } from "./ImageUploadDraggableBtn.vue?vue&type=template&id=1a480f66&scoped=true"
import script from "./ImageUploadDraggableBtn.vue?vue&type=script&lang=js"
export * from "./ImageUploadDraggableBtn.vue?vue&type=script&lang=js"
import style0 from "./ImageUploadDraggableBtn.vue?vue&type=style&index=0&id=1a480f66&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a480f66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a480f66')) {
      api.createRecord('1a480f66', component.options)
    } else {
      api.reload('1a480f66', component.options)
    }
    module.hot.accept("./ImageUploadDraggableBtn.vue?vue&type=template&id=1a480f66&scoped=true", function () {
      api.rerender('1a480f66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/upload/ImageUploadDraggableBtn.vue"
export default component.exports